<template>
  <div class="unit-container app-container">
    <el-row :gutter="20">
      <el-col 
        v-for="unit in list" 
        :key="unit.Id" 
        :xs="24" 
        :sm="12" 
        :md="8" 
        :lg="6"
        class="unit-item"
      >
        <el-card shadow="hover">
          <div slot="header" class="unit-header">
            <h3>{{ unit.Name }}</h3>
            <div>
              <el-tag type="success" effect="dark">
                {{ unit.Price }}金币
              </el-tag>
              <el-tag :type="unit.Type === 'Permanent' ? 'warning' : 'info'" style="margin-left: 5px;">
                {{ unit.Type === 'Permanent' ? '永久' : '消耗品' }}
              </el-tag>
            </div>
          </div>
          <div class="unit-content">
            <p class="description">{{ unit.Description }}</p>
            <div class="meta-info">
              <el-tag type="info">冷却: {{ unit.Interval }}秒</el-tag>
              <el-tag v-if="unit.Type !== 'Permanent'" type="info">使用次数: {{ unit.UsageLimit }}</el-tag>
              <el-tag type="info">适用阵营: {{ formatFactionNames(unit.ApplicableFactionTypes) }}</el-tag>
              <el-tag type="info">适用模式: {{ formatGameTypeNames(unit.ApplicableGameTypes) }}</el-tag>
              <el-tag v-if="unit.RequiredPermissionLevel > 0" :type="getPermissionType(unit.RequiredPermissionLevel)">
                {{ getPermissionText(unit.RequiredPermissionLevel) }}
              </el-tag>
            </div>
          </div>
          <div class="unit-footer">
            <el-button 
              type="primary" 
              @click="handlePurchase(unit.Id)"
              :loading="loadingMap[unit.Id]"
            >
              <i class="el-icon-shopping-cart"></i> 立即购买
            </el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-pagination
      layout="total, prev, pager, next"
      :current-page="page"
      :page-size="20"
      :total="total"
      @current-change="handlePageChange"
    />
  </div>
</template>

<script>
import { getUnits, purchaseUnit, getFactionTypes, getGameTypes } from '@/api/api'

export default {
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      loadingMap: {},
      factionList: [],
      gameTypeList: [],
      dataLoading: true
    }
  },
  methods: {
    handleQuery() {
      this.dataLoading = true
      getUnits({
        page: this.page,
        pageSize: 20
      }).then(res => {
        if (res.data.success) {
          const response = res.data.response
          this.list = response.data
          this.total = response.dataCount
        }
      }).finally(() => {
        this.dataLoading = false
      })
    },

    fetchMetaData() {
      Promise.all([
        getFactionTypes(),
        getGameTypes()
      ]).then(([factions, gameTypes]) => {
        this.factionList = factions.data.response
        this.gameTypeList = gameTypes.data.response
      })
    },

    async handlePurchase(unitId) {
      this.$set(this.loadingMap, unitId, true)
      try {
        const res = await purchaseUnit(unitId)
        if (res.data.success) {
          this.$message.success(res.data.msg || '购买成功')
          this.handleQuery()
        } else {
          this.handlePurchaseError(res)
        }
      } catch (error) {
        this.handlePurchaseError(error.response)
      } finally {
        this.$set(this.loadingMap, unitId, false)
      }
    },

    handlePurchaseError(res) {
      if (res.data.msg.includes('未绑定游戏角色')) {
        this.$confirm('需要先绑定游戏角色，是否前往绑定？', '提示', {
          confirmButtonText: '去绑定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/usercenter/profile')
        })
      } else {
        this.$message.error(res.data.msg || '购买失败')
      }
    },

    formatFactionNames(factionNames) {
      if (!factionNames || this.dataLoading) return '加载中...'
      return factionNames.split(',').map(name => {
        const faction = this.factionList.find(f => f.Name === name.trim())
        return faction ? faction.Description : name
      }).join('、')
    },

    formatGameTypeNames(gameTypes) {
      if (!gameTypes || this.dataLoading) return '加载中...'
      return gameTypes.split(',').map(name => {
        const type = this.gameTypeList.find(t => t.Name === name.trim())
        return type ? type.Description : name
      }).join('、')
    },

    handlePageChange(val) {
      this.page = val
      this.handleQuery()
    },

    getPermissionType(level) {
      const types = ['', 'success', 'warning', 'danger']
      return types[level] || 'info'
    },

    getPermissionText(level) {
      const texts = ['无限制', '总督权限', '提督权限', '舰长权限']
      return texts[level] || '未知权限'
    }
  },
  mounted() {
    this.handleQuery()
    this.fetchMetaData()
  }
}
</script>

<style scoped>
.unit-container {
  padding: 20px;
}

.unit-item {
  margin-bottom: 20px;
}

.unit-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.unit-header h3 {
  margin: 0;
  font-size: 16px;
}

.unit-content {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.description {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 10px;
}

.meta-info {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.meta-info .el-tag {
  max-width: 100%;
  white-space: normal;
  word-break: break-all;
  height: auto;
  min-height: 28px;
  line-height: 1.4;
  padding: 4px 8px;
  margin: 2px 0;
  align-items: center;
}

.el-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.unit-footer {
  margin-top: 15px;
  text-align: center;
}
</style>
